import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import { updateSubscriptionData } from '../Landing/Helper/helper.js'
import { getSubscriptionDataById } from '../Data/SubscriptionCenterDataSource.js'
import { updateFundSubscriptionBySubscriptionId } from './Data/subscriptions.js'
import EmailSubscriptionCenterModal from './EmailSubscriptionCenterModal.jsx'
import {
  compareParameters,
  subtractParams,
} from '../../../spa/utility/index.js'
/**
 * Button that automatically subscribes to a single subscription, when logged in, otherwise pops modal
 */
function SubscribeModalButton(props) {
  const {
    subscriptionId,
    useUnlabeledButton,
    useUnlabeledButtonInst,
    useInlineButton,
    useCheckBoxButton,
    subscriptionProfile,
    currentDoc,
    subs,
    handleClicked,
    updateSubscriptions,
    buttonStyle,
    unsubscribeCustomText,
    subscribeCustomText,
    openModalWithQueryString,
  } = props

  const getButtonColor = (color) => {
    const buttons = {
      tertiary: 'Button--secondary Button--reversed ',
      raspberry: 'Button--primary  Button--raspberry',
      default: 'Button--primary u-borderColorReversed',
    }
    return buttons[color] || buttons.default
  }
  let buttonColor = getButtonColor(buttonStyle)

  const [showModal, setShowModal] = useState(false)
  const [doc, setDoc] = useState(null)
  const [docs, setDocs] = useState([])

  useEffect(() => {
    if (subscriptionId) {
      getDataForSubscriptionId()
    } else if (currentDoc) {
      setDoc(currentDoc)
    }

    return () => {}
  }, [subscriptionId, currentDoc])

  useEffect(() => {
    if (!doc) return
    const openOnLoad =
      compareParameters(
        decodeURIComponent(openModalWithQueryString),
        window.location.search
      ) && showModal === false
    if (openOnLoad) {
      const _doc = { ...doc }
      if (isLoggedIntoSubscriptionCenter()) {
        if (!doc.checked) {
          if (updateSubscriptions) {
            updateSubscriptions(_doc.id)
          }
          _doc.selected = true
          _doc.checked = _doc.selected
          const update = async () => {
            await updateFundSubscriptionBySubscriptionId(
              subscriptionProfile,
              _doc.docId ?? _doc.id,
              _doc.selected
            )
            setDoc(_doc)
          }
          update()
        }
        window.history.replaceState({}, '', window.location.pathname)
      } else {
        setDocs(parseDocs(_doc))
        setDoc(_doc)
        setShowModal(true)
      }
    }
  }, [doc])

  const getDataForSubscriptionId = async () => {
    const sub = await getSubscriptionDataById(subscriptionId)
    if (isLoggedIntoSubscriptionCenter() && subscriptionProfile) {
      updateSubscriptionData(subscriptionProfile.value, {
        subscriptions: [sub],
      })
    }
    setDoc(sub)
  }

  const handleCloseModalClick = () => {
    setShowModal(false)
    const usp = subtractParams(
      window.location.search,
      decodeURIComponent(openModalWithQueryString)
    )
    const url = `${window.location.pathname}${
      usp.toString() ? `?${usp.toString()}` : ''
    }`
    window.location.replace(url)
  }

  const parseDocs = (doc) => {
    let _subs = subs ? [...subs] : []

    _subs.forEach((sub) => {
      if (sub.id === doc.id) {
        sub.selected = doc.selected
      }
    })

    return _subs
  }

  const handleSingleSubscribeClicked = async (event) => {
    event.persist()
    const _doc = { ...doc }

    if (updateSubscriptions) {
      updateSubscriptions(_doc.id)
    }

    if (isLoggedIntoSubscriptionCenter()) {
      _doc.selected = event.currentTarget.dataset.unsubscribe !== 'true'
      _doc.checked = _doc.selected
      await updateFundSubscriptionBySubscriptionId(
        subscriptionProfile,
        _doc.docId ?? _doc.id,
        _doc.selected
      )
      setDoc(_doc)
    } else {
      _doc.selected = true

      setDocs(parseDocs(_doc))
      setDoc(_doc)
      setShowModal(true)
    }

    if (handleClicked) {
      handleClicked(_doc)
    }
  }

  const getNotYetSubscribedButton = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          className="Button Button--secondary u-paddingLeft0 u-block u-marginTop1gu u-textNoTransform u-flex"
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc.category)}
          data-analytics-product={_doc.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <i className="adel-material-symbols u-textColorBrand u-marginRight1gu u-textSizeMsrp1">
            mail_outline
          </i>
          Subscribe to {_doc.name}
        </button>
      )
    )
  }

  const getSubscribedButton = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          data-unsubscribe="true"
          className="Button Button--secondary u-paddingLeft0 u-block u-marginTop1gu u-textNoTransform u-flex"
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc.category)}
          data-analytics-product={_doc.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span className="adel-material-symbols u-textColorBrand u-marginRight1gu u-textSizeMsrp1 u-posRelative">
            mail_outline
            <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon">
              check
            </span>
          </span>
          Subscribed to {_doc.name}
        </button>
      )
    )
  }

  const getUnlabeledNotYetSubscribedButton = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          className={`Button Button--block u-marginTop3gu u-flex u-flexAlignItemsCenter u-flexJustifyCenter ${buttonColor} `}
          data-analytics-category={analyticsSwapAuthor(_doc.category)}
          data-analytics-product={_doc.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span className="adel-material-symbols u-marginRight1gu u-posRelative`">
            mail_outline
          </span>
          {subscribeCustomText ? subscribeCustomText : 'Subscribe'}
        </button>
      )
    )
  }

  const getUnlabeledSubscribedButton = (_doc) => {
    const getButtonStyle = (style) => {
      const buttonStyles = {
        tertiary: 'Button--secondary Button--reversed',
        raspberry:
          'Button Button--primary Button--raspberry u-flex u-flexAlignItemsCenter',
        default:
          'Link u-textColorBrand  u-textSecondary u-textUppercase u-paddingVert2gu u-textSizeMsr u-flex u-flexExpand',
      }
      return buttonStyles[style] || buttonStyles.default
    }
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          data-unsubscribe="true"
          className={`u-marginTop3gu ${getButtonStyle(buttonStyle)}`}
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc.category)}
          data-analytics-product={_doc.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span
            className={`Icon--material ${
              buttonStyle === 'tertiary' || buttonStyle === 'raspberry'
                ? ''
                : 'u-textColorBrand '
            } u-marginRight1gu u-textSizeMsrp2 u-posRelative`}
          >
            mail_outline
            <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon">
              check
            </span>
          </span>
          {unsubscribeCustomText || 'Subscribed'}
        </button>
      )
    )
  }

  const getUnlabeledNotYetSubscribedButtonInst = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          className={`Button Button--block  ${buttonColor} u-flex u-flexAlignItemsCenter u-flexJustifyCenter u-bgColorTransparent`}
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc?.category)}
          data-analytics-product={_doc?.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span className="adel-material-symbols u-marginRight2gu">
            mail_outline
          </span>
          {subscribeCustomText || 'Subscribe'}
        </button>
      )
    )
  }

  const getUnlabeledSubscribedButtonInst = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          data-unsubscribe="true"
          className={`Button Button--block ${buttonColor} u-flex u-flexAlignItemsCenter u-flexJustifyCenter u-bgColorTransparent`}
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc?.category)}
          data-analytics-product={_doc?.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span className="adel-material-symbols u-marginRight2gu u-posRelative">
            mail_outline
            <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon">
              check
            </span>
          </span>
          {unsubscribeCustomText || 'Subscribed'}
        </button>
      )
    )
  }

  const getNotYetInlineSubscribedButton = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          className="Link u-textSecondary u-textKernLoose u-padding0 u-flex u-flexAlignItemsCenter"
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc.category)}
          data-analytics-product={_doc.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span
            className="adel-material-symbols u-textColorBrand u-marginRight1gu u-textSizeMsrp1"
            style={{ transform: 'translateY(-2px)' }}
          >
            mail_outline
          </span>
          {subscribeCustomText || 'Subscribe'}
        </button>
      )
    )
  }

  const getInlineSubscribedButton = (_doc) => {
    return (
      _doc && (
        <button
          onClick={handleSingleSubscribeClicked}
          data-unsubscribe="true"
          className="Link u-textSecondary u-textKernLoose u-padding0 u-flex u-flexAlignItemsCenter"
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(_doc.category)}
          data-analytics-product={_doc.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span
            className="adel-material-symbols u-textColorBrand u-marginRight1gu u-textSizeMsrp1 u-posRelative"
            style={{ transform: 'translateY(-2px)' }}
          >
            mail_outline
            <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon">
              check
            </span>
          </span>
          {unsubscribeCustomText || 'Subscribed'}
        </button>
      )
    )
  }

  const getCheckBoxSubscribeButton = (_doc, checked) => {
    const docId = 'checkBox' + _doc.id
    const copy = checked ? 'Subscribed' : 'Subscribe'

    return (
      <>
        <input
          onChange={handleSingleSubscribeClicked}
          id={docId}
          data-unsubscribe={checked}
          type="checkbox"
          className="Add-to-cart u-posRelative"
          checked={checked}
        ></input>
        <label
          htmlFor={docId}
          className="u-textColorBrandLight u-textSecondary u-marginLeft1gu"
        >
          {copy}
        </label>
      </>
    )
  }

  const getSubscriptions = () => {
    const subs = JSON.parse(JSON.stringify([doc]))
    subs[0].checked = true
    return subs
  }

  const analyticsSwapAuthor = (category) => {
    return category === 'Author' ? 'Authors' : category
  }

  return (
    <>
      {showModal && (
        <EmailSubscriptionCenterModal
          subscriptions={getSubscriptions()}
          docs={docs}
          isLoggedIn={isLoggedIntoSubscriptionCenter()}
          handleCloseModalClick={handleCloseModalClick}
        />
      )}

      {!useUnlabeledButton &&
        !useUnlabeledButtonInst &&
        !useInlineButton &&
        !useCheckBoxButton &&
        (doc && doc.checked
          ? getSubscribedButton(doc)
          : getNotYetSubscribedButton(doc))}
      {useUnlabeledButton &&
        (doc && doc.checked
          ? getUnlabeledSubscribedButton(doc)
          : getUnlabeledNotYetSubscribedButton(doc))}
      {useUnlabeledButtonInst &&
        (doc && doc.checked
          ? getUnlabeledSubscribedButtonInst(doc)
          : getUnlabeledNotYetSubscribedButtonInst(doc))}
      {useInlineButton &&
        (doc && doc.checked
          ? getInlineSubscribedButton(doc)
          : getNotYetInlineSubscribedButton(doc))}
      {useCheckBoxButton &&
        doc &&
        getCheckBoxSubscribeButton(doc, doc.checked || doc.selected)}
    </>
  )
}

SubscribeModalButton.propTypes = {
  subscriptionId: PropTypes.string,
  useUnlabeledButton: PropTypes.bool,
  useUnlabeledButtonInst: PropTypes.bool,
  useInlineButton: PropTypes.bool,
  subscriptionProfile: PropTypes.object,
  handleClicked: PropTypes.func,
  useCheckBoxButton: PropTypes.bool,
  currentDoc: PropTypes.any,
  subs: PropTypes.any,
  updateSubscriptions: PropTypes.any,
  buttonStyle: PropTypes.string,
  unsubscribeCustomText: PropTypes.string,
  subscribeCustomText: PropTypes.string,
  openModalWithQueryString: PropTypes.string,
}

export default SubscribeModalButton
